<template>
	<div id="division">
		<div class="cent">
			<addinfo @addinfo="addinfo"></addinfo>
		</div>
	</div>
</template>

<script>
	import addinfo from 'components/addinfo/addinfo'
	
	import {postaddinfo} from 'network/user'
	
	export default{
		name:'division',
		data(){
			return{
				
			}
		},
		methods:{
			addinfo(info){
				postaddinfo(info).then(res => {
					this.$notify({
						title: '成功',
						message: '投稿成功',
						type: 'success'
					});
				})
			}
		},
		components:{
			addinfo,
		}
	}
</script>

<style scoped>
	#division{
		float: right;
		/* border: solid 2px #ff557f; */
		width: calc(100vw - 410px);
	}
	.cent{
		width: 500px;
		margin-top: 30px;
		margin-left: 23%;
	}
</style>